<template>
  <EcsSideBarTileContent
    class="side-bar-tile-content"
    :header="header"
    :counter="interactions.length"
    :show-counter="showCounter"
    two-line
  >
    <template>
      <v-virtual-scroll
        class="scroller custom-scrollbar"
        :items="interactionsToDisplay"
        :item-height="72"
        :height="maxHeight - 53"
        :bench="1"
      >
        <template v-slot="{ item }">
          <component
            :is="getSideBarItem(item)"
            v-if="!item.loadMore"
            :key="item.id"
            :class="{ active: !isPending && isFocused(item.interactionId), sideBarItem: !isPending }"
            :interaction="item"
          />
          <SideBarLoadMoreBtn v-else />
        </template>
      </v-virtual-scroll>
    </template>
  </EcsSideBarTileContent>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EcsSideBarChatInteractionItem from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/EcsSideBarChatInteractionItem';
import EcsSideBarSmsInteractionItem from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/EcsSideBarSmsInteractionItem';
import EcsSideBarTelephonyInteractionItem from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/EcsSideBarTelephonyInteractionItem';
import EcsSideBarEmailInteractionItem from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/EcsSideBarEmailInteractionItem';
import EcsSideBarPendingInteractionItem from '@/components/ecs-app-side-bar/ecs-side-bar-pending-interaction-item/EcsSideBarPendingInteractionItem';
import SideBarLoadMoreBtn from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/side-bar-load-more-btn/SideBarLoadMoreBtn';

export default {
  name: 'EcsSideBarInteractionList',

  components: {
    EcsSideBarChatInteractionItem,
    EcsSideBarTelephonyInteractionItem,
    EcsSideBarEmailInteractionItem,
    EcsSideBarPendingInteractionItem,
    EcsSideBarSmsInteractionItem,
    SideBarLoadMoreBtn
  },

  props: {
    header: {
      type: String,
      default: ''
    },
    interactions: {
      type: Array,
      default() {
        return [];
      }
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    isPending: {
      type: Boolean,
      default: false
    },
    hideLoadMore: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapGetters('WINDOWS', ['focusedInteractionId']),

    interactionsToDisplay() {
      return this.hideLoadMore ? this.interactions : [...this.interactions, { loadMore: true }];
    }
  },

  methods: {
    ...mapActions('INTERACTIONS', ['requestAgentInteractionHistory']),

    isFocused(interactionId) {
      return this.focusedInteractionId === interactionId;
    },

    getSideBarItem(item) {
      let result;

      if (this.isPending) {
        result = 'EcsSideBarPendingInteractionItem';
      } else if (item.isChat) {
        result = 'EcsSideBarChatInteractionItem';
      } else if (item.isTelephony) {
        result = 'EcsSideBarTelephonyInteractionItem';
      } else if (item.isSms) {
        result = 'EcsSideBarSmsInteractionItem';
      } else {
        result = 'EcsSideBarEmailInteractionItem';
      }

      return result;
    },

    loadMore() {
      this.requestAgentInteractionHistory();
    }
  }
};
</script>

<style scoped>
.load-more-btn {
  margin: 0 auto;
}
.side-bar-item {
  transition: background-color 0.2s ease;
}
.side-bar-item.active,
.side-bar-item:hover {
  background-color: var(--v-hover-background);
}
.side-bar-tile-content {
  padding: 0;
  width: 100%;
}
</style>
